/* eslint-disable */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PrivateCloudIcon extends BaseIcon {
  getChildren = () => [ <g fill={ this.getColor() }>
    <path
      d="M27.46,15.89a3.12,3.12,0,0,0,.23-1.38A9,9,0,0,0,19,5.15h-.24a8.87,8.87,0,0,0-8.46,6.4,9.66,9.66,0,0,0-2.51-.45,8.34,8.34,0,0,0-8,8.45A8.21,8.21,0,0,0,7.8,28H25.42a6.45,6.45,0,0,0,6.37-5.77A6,6,0,0,0,27.46,15.89Z"/>
    <circle fill='white' cx="17" cy="16" r="3"/>
    <rect fill='white' x="16" y="18.33" width="2" height="4.67" rx="1"/>
  </g> ]
  getViewBox = () => '0 0 32 32'
}
